
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/universities/[country]",
      function () {
        return require("private-next-pages/universities/[country].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/universities/[country]"])
      });
    }
  